import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export interface Tab {
  name: string | TimeRangeTabNameEnum;
  counter$?: Observable<number>;
  active: boolean;
  value: string;
}

export enum TimeRangeTabNameEnum {
  days = 'Days',
  weeks = 'Weeks',
  months = 'Months',
  years = 'Years',
}

export enum UnknownPropertyFromBackend {
  unknown = 'unknown',
}

@Component({
  selector: 'vi-tabs',
  templateUrl: 'tabs.component.html',
  styleUrls: ['tabs.component.scss'],
  standalone: true,
  imports: [MatTabsModule, NgForOf, NgIf, AsyncPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViTabsComponent implements OnInit, OnDestroy {
  @Input() tabs: Tab[];
  @Input() changeSelectedTab = new Observable<string>();
  @Input() animationDuration: number = 500;
  @Output() select: EventEmitter<Tab> = new EventEmitter<Tab>();

  active = false;
  selected: number;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.changeSelectedTab.pipe(takeUntil(this.ngUnsubscribe)).subscribe((tabValue) => {
      for (let i = 0; i < this.tabs.length; i++) {
        if (this.tabs[i].value === tabValue) {
          this.selected = i;
          this.changeDetectorRef.detectChanges();
          break;
        }
      }
    });
  }

  onTabClick(clickedTab: Tab): void {
    this.tabs.forEach((tab) => {
      tab.active = false;
    });
    clickedTab.active = true;
    this.select.emit(clickedTab);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
